import React, { useState } from 'react';
import { getIn18Text, apiHolder as api } from 'api';
import Styles from './lock-app.module.scss';
import { Button } from 'antd';
import Login from '@web-account/Login/index';
const systemApi = api.api.getSystemApi();
const LockApp = () => {
    const [isUnlocking, setIsUnLocking] = useState(false);
    const handleUnLock = () => {
        setIsUnLocking(true);
    };
    const handlerResetPasswordHandler = () => {
        console.log('handlerResetPasswordHandler');
    };
    const handleAppUnLockSuccess = () => {
        systemApi.unLockApp();
    };
    const hanleLoginBackClicked = () => {
        setIsUnLocking(false);
    };
    const getLockAccount = () => {
        const currentUser = systemApi.getCurrentUser();
        if (currentUser && currentUser.id) {
            const loginAccount = currentUser.loginAccount || currentUser.id;
            return loginAccount;
        }
        return '';
    };
    const lockAccount = getLockAccount();
    return (React.createElement("div", { className: Styles.container },
        React.createElement("div", { className: Styles.wrapper },
            !isUnlocking && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: Styles.lockIcon }),
                React.createElement("div", { className: Styles.lockTitle }, getIn18Text('LOCK_APP_TITLE_PRE') + lockAccount + getIn18Text('LOCK_APP_TITLE_POST')),
                React.createElement("div", { className: Styles.lockTip }, getIn18Text('LOCK_APP_TIP')),
                React.createElement("div", { className: Styles.btnWrapper },
                    React.createElement(Button, { type: "primary", size: "large", onClick: handleUnLock }, getIn18Text('UNLOCK_BTN'))))),
            isUnlocking && (React.createElement(Login, { type: "unlockApp", initAccount: lockAccount, shouldShowBack: true, onBackClicked: hanleLoginBackClicked, onUnLockAppSuccess: handleAppUnLockSuccess, handlerResetPassword: handlerResetPasswordHandler, backStyle: {
                    left: '20px',
                    top: '15px',
                } })))));
};
export default LockApp;
